import React from "react";
import {
  Checkbox,
  FormControlLabel,
  FormGroup,
  Typography,
} from "@mui/material";

interface Option {
  value: string | number;
  label: string;
}

interface MultiSelectCheckboxFilterProps {
  options: Option[];
  onChange: (selectedOptions: (string | number)[]) => void;
  selectedValues: (string | number)[];
  setSelectedValues: (selectedValues: (string | number)[]) => void;
}

const MultiSelectCheckboxFilter: React.FC<MultiSelectCheckboxFilterProps> = ({
  options,
  onChange,
  selectedValues,
  setSelectedValues,
}) => {
  const handleCheckboxChange = (value: string) => {
    const updatedValues = selectedValues.includes(value)
      ? selectedValues.filter((item) => item !== value)
      : [...selectedValues, value];

    setSelectedValues(updatedValues);
    onChange(updatedValues);
  };

  return (
    <FormGroup>
      <Typography variant="subtitle2" gutterBottom>
        Select options:
      </Typography>
      {options.map((option) => (
        <FormControlLabel
          key={option.value}
          control={
            <Checkbox
              checked={selectedValues.includes(String(option.value))}
              onChange={() => handleCheckboxChange(String(option.value))}
            />
          }
          label={option.label}
        />
      ))}
    </FormGroup>
  );
};

export default MultiSelectCheckboxFilter;
